'use client';

import { createContext, useContext, type ReactNode } from 'react';

export enum UserMenuInitialTab {
  PlansUsage = 'plans-usage',
  Profile = 'profile',
}

export interface OpenUserMenuOptions {
  initialTab?: UserMenuInitialTab;
}

export interface LayoutActionsContextValue {
  openUserMenu: (options?: OpenUserMenuOptions) => void;
}

const LayoutActionsContext = createContext<LayoutActionsContextValue | null>(null);

export function LayoutActionsProvider({
  value,
  children,
}: {
  value: LayoutActionsContextValue;
  children: ReactNode;
}) {
  return (
    <LayoutActionsContext.Provider value={value}>
      {children}
    </LayoutActionsContext.Provider>
  );
}

export function useLayoutActions() {
  const context = useContext(LayoutActionsContext);
  if (!context) {
    throw new Error('useLayoutActions must be used within LayoutActionsProvider');
  }
  return context;
}

export function useOptionalLayoutActions() {
  return useContext(LayoutActionsContext);
}

export const useLayoutActionsContext = useLayoutActions;
export const useOptionalLayoutActionsContext = useOptionalLayoutActions;
